import React from 'react';
import {
  Assignment,
  Devices,
  FilterNone,
  Groups,
  LocationOn,
  MonitorHeart,
  Person,
  PhoneAndroid,
  Summarize,
  Work
} from '@mui/icons-material';
import Strings from '../../../i18n';
import { systemModuleEnum } from '../../../constants/systemRolesEnums';

export const itemsServerAccessMenu: {
  icon: React.ReactNode;
  text: string;
  url: string;
  key: string;
}[] = [
  {
    icon: <Groups />,
    text: Strings.serverAccess.menu.organizations,
    url: '/organizations',
    key: systemModuleEnum.organizations
  },
  {
    icon: <Devices />,
    text: Strings.serverAccess.menu.versions,
    url: '/firmwareVersions',
    key: systemModuleEnum.versions
  },
  {
    icon: <FilterNone />,
    text: Strings.serverAccess.menu.productsModels,
    url: '/',
    key: systemModuleEnum.products
  },
  {
    icon: <Person />,
    text: Strings.serverAccess.menu.users,
    url: '/users',
    key: systemModuleEnum.users
  },
  {
    icon: <LocationOn />,
    text: Strings.serverAccess.menu.locations,
    url: '/all-locations',
    key: systemModuleEnum.locations
  },
  {
    icon: <PhoneAndroid />,
    text: Strings.serverAccess.menu.devices,
    url: '/server-access/devices',
    key: systemModuleEnum.devices
  },
  {
    icon: <PhoneAndroid />,
    text: Strings.serverAccess.menu.deviceAnnounce,
    url: '/server-access/device-announce',
    key: systemModuleEnum.deviceAnnounce
  },
  {
    icon: <Assignment />,
    text: Strings.serverAccess.menu.firmwareSchedule,
    url: '/server-access/firmware-schedule',
    key: systemModuleEnum.firmwareSchedule
  },
  {
    icon: <Summarize />,
    text: Strings.serverAccess.menu.reports,
    url: '/reports',
    key: systemModuleEnum.reports
  },
  {
    icon: <MonitorHeart />,
    text: Strings.serverAccess.menu.serviceHealth,
    url: '/service-health',
    key: systemModuleEnum.serviceHealth
  },
  {
    icon: <Work />,
    text: Strings.serverAccess.menu.webJobs,
    url: '/server-access/web-jobs',
    key: systemModuleEnum.webJobs
  }
];
